import React, { useEffect, useState } from "react";
// import './AdmitPage.css';
import {
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Button,
  Table,
  AppBar,
  Toolbar,
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Snackbar,
  Alert,
  Modal,
  ButtonGroup,
} from "@mui/material";
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;

const ModalComponent = ({ open, handleClose, title, message, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90vw', sm: '500px' },
          borderRadius: '25px',
          p: 4,
          zIndex: 1600,
        }}
      >
        <Box
          sx={{
            bgcolor: '#B6B09F',
            borderRadius: '25px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'visible',
          }}
        >
          <Box
            sx={{
              // bgcolor: '#3E3F29',
              bgcolor: 'linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)',

              p: 2,
              borderTopLeftRadius: '15px',
              borderTopRightRadius: '15px',
              position: 'relative',
              zIndex: 1,
            }}
          >
            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              sx={{
                color: 'white',
                textTransform: 'capitalize',
                fontFamily: 'Nunito',
                fontSize: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
              }}
            >
              <span>{title}⚠️</span>
            </Typography>
          </Box>
          <Box
            sx={{
              bgcolor: 'white',
              p: 2,
              borderBottomLeftRadius: '15px',
              borderBottomRightRadius: '15px',
              zIndex: 1,
            }}
          >
            <Typography
              id="modal-description"
              sx={{ color: 'black', mb: 2, textAlign: 'left' }}
            >
              {message}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1,
                mt: 2,
                flexWrap: 'wrap',
                alignItems: 'center',
              }}
            >
              <Button
                variant="outlined"
                onClick={handleClose}
                sx={{
                  width: '50px !important',
                  minWidth: '50px !important',
                  maxWidth: '50px !important',
                  height: '30px !important',
                  color: 'red',
                  border: 'none !important',
                  '&:hover': {
                    color: 'green',
                  },
                  borderRadius: '25px',
                  padding: '8px 16px',
                  flex: '0 0 auto',
                }}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

const AdmitPage = () => {
  const [examTypes, setExamTypes] = useState([]);
  const [subExams, setSubExams] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState("");
  const [selectedSubExam, setSelectedSubExam] = useState("");
  const [classNames, setClassNames] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState("");
  const [sessions, setSessions] = useState([]);
  const [session, setSession] = useState("");
  const [selectedSession, setSelectedSession] = useState("");
  const [subjectDetails, setSubjectDetails] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [isExamModeIndependent, setIsExamModeIndependent] = useState(0);
  const [isSubExamDisabled, setIsSubExamDisabled] = useState(true);

  const navigate = useNavigate();

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDateChange = (index, event) => {
    const updatedSubjectDetails = [...subjectDetails];
    updatedSubjectDetails[index].date = event.target.value;
    setSubjectDetails(updatedSubjectDetails);
  };

  const handleStartTimeChange = (index, event) => {
    const updatedSubjectDetails = [...subjectDetails];
    updatedSubjectDetails[index].startTime = event.target.value;
    setSubjectDetails(updatedSubjectDetails);
  };

  const handleEndTimeChange = (index, event) => {
    const updatedSubjectDetails = [...subjectDetails];
    updatedSubjectDetails[index].endTime = event.target.value;
    setSubjectDetails(updatedSubjectDetails);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const fetchExamTypes = async () => {
      try {
        const Url = process.env.REACT_APP_BASE_URL;
        const apiUrl = `${Url}/ExaminationCriteria/GetExaminationCriteria`;
        const token = sessionStorage.getItem("token");
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ examCategoryId: 0 }),
        });
        const data = await response.json();

        if (data && Array.isArray(data)) {
          setExamTypes(data);
        } else {
          setSnackbarMessage("No exam types found.");
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error fetching exam types:", error);
        setSnackbarMessage("Failed to fetch exam types. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    };

    fetchExamTypes();
  }, []);

  useEffect(() => {
    if (!selectedExamType) return;

    const selectedExam = examTypes.find(
      (exam) => exam.examCriteriaId === selectedExamType
    );

    if (selectedExam) {
      setIsExamModeIndependent(selectedExam.isExamModeIndependent);

      if (selectedExam.isExamModeIndependent === 1) {
        setIsSubExamDisabled(true);
        setSelectedSubExam("");
        setSubExams([]);
        setSnackbarMessage(
          "Sub-exam selection is disabled as the exam mode is independent."
        );
        setSnackbarSeverity("info");
        setSnackbarOpen(true);
      } else {
        setIsSubExamDisabled(false);
      }
    }
  }, [selectedExamType, examTypes]);

  useEffect(() => {
    if (!selectedExamType || isExamModeIndependent === 1) return;

    const fetchSubExams = async () => {
      try {
        const Url = process.env.REACT_APP_BASE_URL;
        const apiUrl = `${Url}/Teacher/ddlExamSubCategory_Examination`;
        const token = sessionStorage.getItem("token");
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ examCategoryId: selectedExamType }),
        });
        const data = await response.json();
if (data && Array.isArray(data) && data.length > 0) {
  // ✅ data present → unlock
  const mappedSubExams = data.map((subExam) => ({
    id: subExam.examSubCategoryId,
    name: subExam.examSubCategory,
  }));

  setSubExams(mappedSubExams);
  setIsSubExamDisabled(false);   // 🔓 clickable
} else {
  // ❌ no data → lock
  setSubExams([]);
  setSelectedSubExam("");
  setIsSubExamDisabled(true);    // 🔒 DIRECT non-clickable
}

       
      } catch (error) {
        console.error("Error fetching sub exams:", error);
        setSnackbarMessage("Failed to fetch sub-exams. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    };

    fetchSubExams();
  }, [selectedExamType, isExamModeIndependent]);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_BASE_URL}/ClassPromotion/GetFinancialYear`;
        const token = sessionStorage.getItem("token");

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (Array.isArray(data) && data.length > 0) {
          const mappedSessions = data.map((session) => ({
            id: session.financialYearID,
            name: session.finanacialYear,
          }));
          setSessions(mappedSessions);

          const today = new Date();
          const currentYear = today.getFullYear();
          const nextYear = currentYear + 1;

          const financialYearStart = new Date(currentYear, 3, 1);
          const financialYearEnd = new Date(nextYear, 2, 31);

          let currentSessionString =
            today >= financialYearStart && today <= financialYearEnd
              ? `${currentYear}-${nextYear}`
              : `${currentYear - 1}-${currentYear}`;

          const currentSession = mappedSessions.find(
            (session) => session.name === currentSessionString
          );

          if (currentSession) {
            setSession(currentSession.id);
          }
        } else {
          setSnackbarMessage("No sessions found.");
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error fetching financial years:", error);
        setSnackbarMessage("Failed to fetch sessions. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    };

    fetchSessions();
  }, []);

  useEffect(() => {
    const fetchClassNames = async () => {
      try {
        const Url = process.env.REACT_APP_BASE_URL;
        const apiUrl = `${Url}/CreateClass/GetClassName`;
        const token = sessionStorage.getItem("token");
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({}),
        });

        const data = await response.json();

        const mappedClassNames = data.map((classData) => ({
          id: classData.classId,
          name: classData.className,
        }));

        setClassNames(mappedClassNames);
      } catch (error) {
        console.error("Error fetching class names:", error);
      }
    };

    fetchClassNames();
  }, []);

  useEffect(() => {
    const fetchSections = async () => {
      if (!selectedClass) return;

      try {
        const Url = process.env.REACT_APP_BASE_URL;
        const apiUrl = `${Url}/Exam/ddlSection_clsId`;
        const token = sessionStorage.getItem("token");
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ classId: selectedClass }),
        });

        const data = await response.json();

        const mappedSections = data.map((section) => ({
          id: section.sectionId,
          name: section.sectionName,
        }));

        setSections(mappedSections);
      } catch (error) {
        console.error("Error fetching sections:", error);
      }
    };

    fetchSections();
  }, [selectedClass]);

  const handleGetDetails = async () => {
    if (!selectedExamType ||
        (!isSubExamDisabled && !selectedSubExam) ||
        !selectedClass || 
        !selectedSection ||
        !session) {
      setOpenDialog(true);
      return;
    }

    try {
      const Url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${Url}/AdmitCard/GetSubjectDetail_ToGenerateAdmitCard`;
      const token = sessionStorage.getItem("token");
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          examType: selectedExamType,
          subExamId: isSubExamDisabled ? 0 : selectedSubExam,
          session: session,
          classId: selectedClass,
          sectionId: selectedSection,
        }),
      });

      const data = await response.json();

      const examDetails = examTypes.find(
        (type) => type.examCriteriaId === selectedExamType
      );
      const minMarks = examDetails ? examDetails.minNumber : 0;
      const maxMarks = examDetails ? examDetails.maxNumber : 0;

      const updatedSubjectDetails = data.data.map((subject) => ({
        subjectId: subject.subjectId,
        subjectName: subject.subjectName,
        date: "",
        startTime: "",
        endTime: "",
        minMarks: minMarks,
        maxMarks: maxMarks,
      }));
      
      setSubjectDetails(updatedSubjectDetails);

      setSnackbarMessage("Generated Admit card data retrieved successfully.");
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error fetching subject details:", error);
      setSnackbarMessage("Error fetching subject details.");
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleSave = async () => {
    console.log("Subject Details Before Save:", subjectDetails);

    const invalidSubjects = subjectDetails.filter(
      (subject) => !subject.date || !subject.startTime || !subject.endTime
    );

    if (invalidSubjects.length > 0) {
      setDialogMessage("Please select a date and time for all subjects.");
      setDialogOpen(true);
      return;
    }

    const validSubjectDetails = subjectDetails.map((subject) => ({
      classId: selectedClass,
      sectionId: selectedSection,
      sessionId: session,
      subjectId: subject.subjectId,
      examCategoryId: selectedExamType,
      subExamId: selectedSubExam || 0,
      examDate: formatDate(subject.date),
      examStartTime: subject.startTime,
      examEndTime: subject.endTime,
      minMarks: subject.minMarks,
      maxMarks: subject.maxMarks,
      admitCardRemarks: "",
    }));

    if (validSubjectDetails.length === 0) {
      setSnackbarMessage("No subject details to save.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    try {
      const Url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${Url}/AdmitCard/InsertAdmitCards`;
      const token = sessionStorage.getItem("token");
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(validSubjectDetails),
      });

      const data = await response.json();
      console.log("API Response:", data);

      if (response.ok) {
        setSelectedExamType("");
        setSelectedSubExam("");
        setSelectedClass("");
        setSelectedSection("");
        setSelectedSession("");
        setSubjectDetails([]);

        setSnackbarMessage("Admit cards saved successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage(data.message || "Failed to save admit cards.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error while saving:", error);
      setSnackbarMessage("Error while saving: " + error.message);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };  

  const handleSessionChange = (event) => setSession(event.target.value);

  return (
    <>
      <Box component="main" sx={{ 
        width: { md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
        mt: { xs: 0, sm: '64px' },
        p: { xs: 1, md: 3 },
        height: 'auto', 
        minHeight: '100vh' 
      }}>
       <AppBar
  position="static"
  sx={{
    background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
    boxShadow: "0 6px 20px #063552",
  }}
>

          <Toolbar>
            <Typography variant="h4"  component="div">
              Create New Admit Card
            </Typography>
          </Toolbar>
        </AppBar>
        <div style={{ display: 'flex', marginTop: 20, marginLeft: -2,gap:'5px'}}>
      <Button
  variant="outlined"
  onClick={() => navigate('/admitcard')}
  sx={{
    width: "250px",
    fontWeight: 600,
    color: "#063552",
    border: "2px solid #063552",
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "rgba(217,119,6,0.08)",
      borderColor: "#063552",
      color: "#063552",
    },
  }}
>
  Admit Card
</Button>

<Button
  variant="contained"
  onClick={() => navigate('/admitpage')}
  sx={{
    width: "250px",
    color: "#fff",
    fontWeight: 600,
    background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
    boxShadow: "0 6px 16px #063552",
    "&:hover": {
      background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
    },
  }}
>
  Create New Admit
</Button>

        </div>
        <Paper elevation={3} sx={{ padding: 4, margin: "auto", maxWidth: '1000px !important', marginTop: 3, height: 'auto', }}>
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="exam-type-label">Exam Type</InputLabel>
                <Select
                  labelId="exam-type-label"
                  id="exam-type"
                  value={selectedExamType}
                  onChange={(e) => setSelectedExamType(e.target.value)}
                  label="Exam Type"
                >
                  {examTypes.map((type) => (
                    <MenuItem key={type.examCriteriaId} value={type.examCriteriaId}>
                      {type.examType}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth >
                <InputLabel id="sub-exam-label">Sub Exam</InputLabel>
                <Select
  labelId="sub-exam-label"
  id="sub-exam"
  value={selectedSubExam}
  onChange={(e) => setSelectedSubExam(e.target.value)}
  label="Sub Exam"
  disabled={isSubExamDisabled}   // 🔒 FINAL LOCK
>

                  {subExams.map((subExam) => (
                    <MenuItem key={subExam.id} value={subExam.id}>
                      {subExam.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel id="session-label">Session</InputLabel>
                <Select
                  labelId="session-label"
                  id="session"
                  value={session}
                  onChange={handleSessionChange}
                  label="Session"
                >
                  {sessions.map((session) => (
                    <MenuItem key={session.id} value={session.id}>
                      {session.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box mt={4} display="flex" justifyContent="center" gap={2}>
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel id="class-label">Class</InputLabel>
              <Select
                labelId="class-label"
                id="class"
                value={selectedClass}
                onChange={(e) => setSelectedClass(e.target.value)}
                label="Class"
              >
                {classNames.map((className) => (
                  <MenuItem key={className.id} value={className.id}>
                    {className.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel id="section-label">Section</InputLabel>
              <Select
                labelId="section-label"
                id="section"
                value={selectedSection}
                onChange={(e) => setSelectedSection(e.target.value)}
                label="Section"
              >
                {sections.map((section) => (
                  <MenuItem key={section.id} value={section.id}>
                    {section.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box mt={4} display="flex" justifyContent="center">
           <Button
  variant="contained"
  onClick={handleGetDetails}
  sx={{
    minWidth: "350px",
    color: "#fff",
    fontWeight: 600,
    background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
    boxShadow: "0 6px 16px #063552",
    "&:hover": {
      background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
    },
  }}
>
  CREATE NEW ADMIT CARD
</Button>

          </Box>
          <Box mt={4} sx={{ height: 'auto', minHeight: 'auto' }}>
         <TableContainer
  component={Paper}
  sx={{
    width: '100%',
    height: 'auto',
    overflowX: 'auto ', // Allow horizontal scrolling on small screens
    overflowY: 'hidden !important',
    mb: '16px',
    maxWidth: '100%', // Ensure container doesn't exceed parent width
  }}
>
  <Table >
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            width: '130px', // Relative width for larger screens
            maxWidth: '130px', // Strict max width
            minWidth: '60px', // Allow columns to shrink for smaller screens
            fontWeight: 'bold',
            backgroundColor: '#f5f5f5',
            fontSize: { xs: '0.8rem', sm: '1rem' }, // Responsive font size
            padding: { xs: '6px', sm: '10px' }, // Responsive padding
            boxSizing: 'border-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Subject
        </TableCell>
        <TableCell
          sx={{
          width: '130px', // Relative width for larger screens
            maxWidth: '130px', // Strict max width
            minWidth: '60px',
            fontWeight: 'bold',
            backgroundColor: '#f5f5f5',
            fontSize: { xs: '0.8rem', sm: '1rem' },
            padding: { xs: '6px', sm: '10px' },
            boxSizing: 'border-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Date
        </TableCell>
        <TableCell
          sx={{
            width: '130px',
            maxWidth: '130px',
            minWidth: '60px',
            fontWeight: 'bold',
            backgroundColor: '#f5f5f5',
            fontSize: { xs: '0.8rem', sm: '1rem' },
            padding: { xs: '6px', sm: '10px' },
            boxSizing: 'border-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Start Time
        </TableCell>
        <TableCell
          sx={{
             width: '130px',
            maxWidth: '130px',
            minWidth: '60px',
            fontWeight: 'bold',
            backgroundColor: '#f5f5f5',
            fontSize: { xs: '0.8rem', sm: '1rem' },
            padding: { xs: '6px', sm: '10px' },
            boxSizing: 'border-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          End Time
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {subjectDetails.length > 0 ? (
        subjectDetails.map((subject, index) => (
          <TableRow key={index}>
            <TableCell
              sx={{
                 width: '130px',
            maxWidth: '130px',
                minWidth: '60px',
                fontSize: { xs: '0.75rem', sm: '0.85rem' },
                padding: { xs: '4px', sm: '12px' },
                boxSizing: 'border-box',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {subject.subjectName}
            </TableCell>
            <TableCell
              sx={{
                width: '130px',
            maxWidth: '130px',
                minWidth: '60px',
                fontSize: { xs: '0.75rem', sm: '0.85rem' },
                padding: { xs: '4px', sm: '6px' },
                boxSizing: 'border-box',
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                type="date"
                value={subject.date}
                onChange={(e) => handleDateChange(index, e)}
                size="small"
                sx={{
                  maxWidth: '100%',
                  '& input': {
                    fontSize: { xs: '0.75rem', sm: '0.85rem' },
                    padding: { xs: '2px', sm: '4px' },
                  },
                }}
              />
            </TableCell>
            <TableCell
              sx={{
                width: '130px',
            maxWidth: '130px',
                minWidth: '60px',
                fontSize: { xs: '0.75rem', sm: '0.85rem' },
                padding: { xs: '4px', sm: '6px' },
                boxSizing: 'border-box',
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                type="time"
                value={subject.startTime}
                onChange={(e) => handleStartTimeChange(index, e)}
                size="small"
                sx={{
                  maxWidth: '100%',
                  '& input': {
                    fontSize: { xs: '0.75rem', sm: '0.85rem' },
                    padding: { xs: '2px', sm: '4px' },
                  },
                }}
              />
            </TableCell>
            <TableCell
              sx={{
                width: '130px',
            maxWidth: '130px',
                minWidth: '60px',
                flexWrap: 'wrap',
                fontSize: { xs: '0.75rem', sm: '0.85rem' },
                padding: { xs: '4px', sm: '6px' },
                boxSizing: 'border-box',
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                type="time"
                value={subject.endTime}
                onChange={(e) => handleEndTimeChange(index, e)}
                size="small"
                sx={{
                  maxWidth: '100%',
                  '& input': {
                    fontSize: { xs: '0.75rem', sm: '0.85rem' },
                    padding: { xs: '2px', sm: '4px' },
                  },
                }}
              />
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell
            colSpan={4}
            align="center"
            sx={{
              fontSize: { xs: '0.75rem', sm: '0.85rem' },
              padding: { xs: '4px', sm: '6px' },
              boxSizing: 'border-box',
            }}
          >
            No subject details found.
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</TableContainer>
          </Box>
          <Box mt={1} display="flex" justifyContent="flex-start" gap={2}>
          <Button
  variant="contained"
  onClick={handleSave}
  disabled={subjectDetails.length === 0}
  sx={{
    width: "150px",
    color: "#eaeaea",
    fontWeight: 600,
    background: "linear-gradient(145deg, #f59e0b 0%, #063552 100%)",
    "&:hover": {
      background: "linear-gradient(145deg, #063552 0%, #063552 100%)",
    },
  }}
>
  Save
</Button>

<Button
  variant="outlined"
  onClick={() => setSubjectDetails([])}
  disabled={subjectDetails.length === 0}
  sx={{
    width: "150px",
    fontWeight: 600,
    color: "#063552",
    border: "2px solid #063552",
    "&:hover": {
      backgroundColor: "rgba(217,119,6,0.08)",
      borderColor: "#063552",
      color: "#063552",
    },
  }}
>
  Cancel
</Button>

          </Box>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
          <ModalComponent
            open={openDialog}
            handleClose={handleDialogClose}
            title="Missing Information"
            message="Please select all required details before proceeding."
            onConfirm={handleDialogClose}
          />
          <ModalComponent
            open={dialogOpen}
            handleClose={() => setDialogOpen(false)}
            title="Validation Errors"
            message={dialogMessage}
            onConfirm={() => setDialogOpen(false)}
          />
        </Paper>
      </Box>
    </>
  );
};

export default AdmitPage;